import React from 'react';
import type { RecordKind } from '../types';
import { RECORD_KIND_LABEL, RECORD_KIND_PILL } from '../utils/verification';

interface KindBadgeProps {
  kind: RecordKind;
  className?: string;
  size?: 'sm' | 'md';
}

export const KindBadge: React.FC<KindBadgeProps> = ({ kind, className = '', size = 'md' }) => {
  const sizing = size === 'sm' ? 'text-[10px] px-1.5 py-0.5' : 'text-xs px-2 py-0.5';
  return (
    <span
      className={`inline-flex items-center rounded-full border font-semibold whitespace-nowrap ${RECORD_KIND_PILL[kind]} ${sizing} ${className}`}
    >
      {RECORD_KIND_LABEL[kind]}
    </span>
  );
};
